export const KEYBOARD_OPENED = 'keyboardOpened'

export const KEYBOARD_CLOSED = 'keyboardClosed'
